<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.orderNo"
        placeholder="订单编号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.userInfo"
        placeholder="会员(电话、姓名)"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.expressNo"
        placeholder="买家发货单号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in AFTER_SALE_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.type"
        placeholder="售后类型"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in AFTER_SALE_TYPE"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.reason"
        placeholder="售后原因"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in AFTER_SALE_REASON"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="create"
        startPlaceholder="申请开始时间"
        endPlaceholder="申请截止时间"
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <!--      <el-button-->
      <!--          class="filter-item"-->
      <!--          icon="el-icon-download"-->
      <!--          @click="handleExport"-->
      <!--          style="margin-left: 10px"-->
      <!--      >导出</el-button-->
      <!--      >-->
    </div>
    <div style="margin-bottom: 5px">售后订单数量:{{ total }}</div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        align="center"
        prop="userId"
        label="用户会员ID"
        width="190"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="orderNo"
        label="订单编号"
        width="190"
      ></el-table-column>
      <el-table-column
        label="用户姓名"
        align="center"
        prop="userName"
        width="100"
      ></el-table-column>
      <el-table-column
        label="用户手机号码"
        align="center"
        prop="mobile"
        width="120"
      ></el-table-column>
      <el-table-column
        class-name="status-col"
        label="状态"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <el-tag
            :color="getValue(AFTER_SALE_STATUS_CSS, scope.row.status)"
            style="color: #FFFFFF"
            >{{ getValue(AFTER_SALE_STATUS, scope.row.status) }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="售后类型"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          {{ getValue(AFTER_SALE_TYPE, scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="原因标签"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          {{ getValue(AFTER_SALE_REASON, scope.row.reason) }}
        </template>
      </el-table-column>

      <el-table-column
        label="付款单编号"
        align="center"
        prop="payOrderId"
        width="120"
      ></el-table-column>
      <el-table-column
        label="退款金额"
        align="center"
        prop="refundAmount"
        width="100"
      ></el-table-column>
      <el-table-column
        class-name="status-col"
        label="买家相关信息"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.buyName }}</span>
          <span>{{ scope.row.buyPhone }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="凭证图片"
        align="center"
        prop="proofImg"
        width="200"
      >
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.proofImg"
            style="width: 100px; height: 100px"
            :src="scope.row.proofImg"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        label="备注"
        align="center"
        prop="remark"
        width="100"
      ></el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="320"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="jumpInfo(scope.row, 'info')"
            class="comm_but_warp"
            >预览</el-button
          >
          <el-button
            type="primary"
            size="mini"
            plain
            @click="checkShipmentsVisible(true, scope.row)"
            class="comm_but_warp"
            v-if="scope.row.status === 3"
            >发货</el-button
          >
          <el-button
            type="warning"
            size="mini"
            plain
            @click="confirmReceipt(scope.row)"
            class="comm_but_warp"
            v-if="scope.row.status === 2"
            >确认收货</el-button
          >
          <el-button
            type="success"
            size="mini"
            plain
            @click="checkFeedbackVisible(true, scope.row)"
            class="comm_but_warp"
            v-if="scope.row.status === 0"
            >反馈</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    发货-->
    <el-dialog
      title="发货"
      :visible.sync="shipmentsVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form
        ref="form"
        :rules="goodsFules"
        :model="goodsForm"
        label-position="left"
        label-width="150px"
        style="width: 90%; margin-left:50px;"
      >
        <el-form-item label="实物商品" prop="refId">
          <el-table
            ref="multipleTable"
            :data="goodsList"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            size="mini"
            v-loading="goodsListLoading"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="id" label="商品编号" width="80">
            </el-table-column>
            <el-table-column prop="title" label="商品名称"> </el-table-column>
            <el-table-column prop="mainGraph" label="商品图" width="100">
              <template slot-scope="scope">
                <el-image
                  style="width: 50px; height: 50px"
                  :src="scope.row.mainGraph"
                  fit="cover"
                ></el-image>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="快递公司" prop="expressld">
          <el-select
            v-model="goodsForm.expressId"
            placeholder="请选择快递公司"
            style="width: 100%"
            class="filter-item"
            clearable
            filterable
          >
            <el-option
              v-for="item in shippingCompanyOption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号" prop="expressNo">
          <el-input v-model="goodsForm.expressNo" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkShipmentsVisible(false, {})">取消</el-button>
        <el-button
          type="primary"
          @click="shipmentsOk"
          :loading="shipmentsBtnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!--    反馈-->
    <el-dialog
      title="售后反馈"
      :visible.sync="feedbackVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form
        ref="feedbackForm"
        :rules="feedbackFules"
        :model="feedbackForm"
        label-position="left"
        label-width="150px"
        style="width: 90%; margin-left:50px;"
      >
        <el-form-item label="结果" prop="status">
          <el-radio-group v-model="feedbackForm.status">
            <el-radio :label="1">受理</el-radio>
            <el-radio :label="2">作废</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkFeedbackVisible(false, {})">取消</el-button>
        <el-button type="primary" @click="feedbackOk" :loading="feedbackLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOrderAfterList,
  getGoodsList,
  deliveryOrderAfterFeedback,
  confirmOrderAfterReceipt,
  feedbackOrderAfter
} from "@/api/order";
import { formatApiDate } from "@/utils/utils";
import {
  getValue,
  AFTER_SALE_STATUS,
  AFTER_SALE_REASON,
  AFTER_SALE_TYPE
} from "@/utils/enumUtile";
import { getExpress } from "@/api/common";
import { AFTER_SALE_STATUS_CSS } from "@/utils/enumUtileCss";
import DataPicker from "@/views/components/dataPicker.vue";
// import {uploadXlsx} from "@/utils";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    AFTER_SALE_STATUS() {
      return AFTER_SALE_STATUS;
    },
    AFTER_SALE_REASON() {
      return AFTER_SALE_REASON;
    },
    AFTER_SALE_TYPE() {
      return AFTER_SALE_TYPE;
    },
    AFTER_SALE_STATUS_CSS() {
      return AFTER_SALE_STATUS_CSS;
    }
  },
  components: { DataPicker },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        orderNo: null,
        userInfo: null,
        type: null,
        status: null,
        createStartTime: null,
        createEndTime: null,
        reason: null,
        expressNo: null
      },
      shipmentsVisible: false,
      goodsList: [],
      goodsListLoading: false,
      goodsFules: {
        expressId: [
          { required: true, message: "快递公司不能为空", trigger: "change" }
        ],
        expressNo: [
          { required: true, message: "快递单号不能为空", trigger: "change" }
        ]
      },
      goodsForm: {
        id: 0,
        itemIds: null,
        expressId: null, // 快递公司ID
        expressNo: null // 快递单号
      },
      shipmentsBtnLoading: false,
      shippingCompanyOption: [], // 发货公司
      feedbackVisible: false,
      feedbackFules: {
        status: [
          { required: true, message: "反馈结果不能为空", trigger: "change" }
        ]
      },
      feedbackForm: {
        id: 0,
        status: null
      },
      feedbackLoading: false
    };
  },
  created() {
    if (this.$route.query.isDetailPage) {
      try {
        const savedState = sessionStorage.getItem("pageState");
        // 只有当 savedState 存在且是有效的 JSON 字符串时才恢复状态
        if (savedState) {
          const parsedState = JSON.parse(savedState);
          // 确保解析后的数据是对象类型
          if (parsedState && typeof parsedState === "object") {
            this.listQuery = { ...this.listQuery, ...parsedState };
          }
        }
        sessionStorage.removeItem("pageState");
      } catch (error) {
        console.error("恢复页面状态失败:", error);
        // 发生错误时不改变原有的 listQuery
      }
    }
    this.getShippingCompany();
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询发货公司
     */
    getShippingCompany() {
      getExpress().then(resp => {
        if (resp && resp.bizcode === 100) {
          this.shippingCompanyOption = resp.data;
        }
      });
    },
    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getOrderAfterList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 跳转到其他页面
     */
    jumpInfo(item) {
      sessionStorage.setItem("pageState", JSON.stringify(this.listQuery));
      this.$router.push({ path: "/order/afterSale/info/" + item.id });
    },

    // 发货 start
    checkShipmentsVisible(status, item) {
      if (status) {
        this.goodsForm.id = item.id;
        this.getGoodsList(item.id);
      } else {
        this.goodsForm.id = 0;
        this.goodsList = [];
        this.$refs.form.resetFields();
      }
      this.shipmentsVisible = status;
    },
    /**
     * 查询订单详情
     */
    getGoodsList(id) {
      this.goodsListLoading = true;
      const params = {
        id
      };
      getGoodsList(params)
        .then(resp => {
          this.goodsList = resp.data;
        })
        .finally(() => {
          this.goodsListLoading = false;
        });
    },
    /**
     * 选择发货商品
     * @param item
     */
    handleSelectionChange(item) {
      this.goodsForm.itemIds = item.map(o => o.id).join(",");
    },
    shipmentsOk() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const form = this.goodsForm;
          if (!form.itemIds) {
            this.$notify({
              title: "提示",
              message: "请选择需要发货的商品",
              type: "warning",
              duration: 1500
            });
            return;
          }
          const params = {
            ...form
          };
          this.shipmentsBtnLoading = true;
          deliveryOrderAfterFeedback(params)
            .then(resp => {
              if (resp && resp.bizcode === 100) {
                this.getList();
                this.checkShipmentsVisible(false);
                this.$notify({
                  title: "成功",
                  message: "发货成功",
                  type: "success",
                  duration: 2000
                });
              }
            })
            .finally(() => {
              this.shipmentsBtnLoading = false;
            });
        }
      });
    },
    // 发货 end
    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(type, value) {
      if (type === "create") {
        this.listQuery.createStartTime = value[0];
        this.listQuery.createEndTime = value[1];
      }
    },
    /**
     * 确认收货
     */
    confirmReceipt(row) {
      this.$confirm("确认收货？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const params = {
          id: row.id
        };
        confirmOrderAfterReceipt(params).then(resp => {
          if (resp && resp.bizcode === 100) {
            this.getList();
            this.$notify({
              title: "成功",
              message: "确认成功",
              type: "success",
              duration: 2000
            });
          }
        });
      });
    },

    checkFeedbackVisible(status, item = {}) {
      if (status) {
        this.feedbackForm.id = item.id;
      } else {
        this.feedbackForm.id = 0;
      }
      this.feedbackVisible = status;
    },
    feedbackOk() {
      this.$refs["feedbackForm"].validate(valid => {
        if (valid) {
          const form = this.feedbackForm;
          const params = {
            ...form
          };
          this.feedbackLoading = true;
          feedbackOrderAfter(params)
            .then(resp => {
              if (resp && resp.bizcode === 100) {
                this.getList();
                this.checkFeedbackVisible(false, {});
                this.$notify({
                  title: "成功",
                  message: "反馈成功",
                  type: "success",
                  duration: 2000
                });
              }
            })
            .finally(() => {
              this.feedbackLoading = false;
            });
        }
      });
    }
    /**
     * 导出
     */
    // handleExport() {
    //   const form = this.listQuery;
    //   const params = {
    //     ...form
    //   };
    //   exportOrderList(params).then(response => {
    //     uploadXlsx(response, "订单表");
    //   });
    // }
  }
};
</script>
<style scoped lang="scss">
.comm_but_warp {
  margin-bottom: 10px;
}
</style>
